<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Featured } from '#library/components.schema.build.ts'
	import CardNews from '#components/card_news.svelte'
	import { format_date } from 'kitto'

	interface Props {
		blok: Blok<Featured>
	}

	let { blok }: Props = $props()
	const stories = $derived(blok.stories?.filter(story => typeof story === 'object'))
</script>

<section class="featured {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		{#if blok.title}
			<p class="title">{blok.title}</p>
		{/if}
		{#if stories}
			<div class="stories">
				{#each stories as story, i (i)}
					<CardNews
						title={story.name}
						image={story.content.image}
						link="/{story.full_slug}"
						suptitle={format_date('{ddd}, {DD} {MMM} {YYYY}', story.first_published_at!)}
						subtitle={story.content.metatags?.description ?? ''}
						caption={story.content.component}
						type={story.content.component}
					/>
				{/each}
			</div>
		{/if}
	</div>
</section>

<style lang="css">
	.featured {
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
		background-color: var(--c-background);
	}

	.contain {
		align-items: start;
		display: grid;
		gap: 2rem;
	}

	.title {
		color: var(--c-foreground);
		font: 600 var(--f-h3);
		letter-spacing: var(--ls-h3);
		text-wrap: balance;
	}

	.stories {
		display: grid;
		gap: 2rem;

		@media (--from-mobile) {
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}
	}
</style>
